// Listen variant click
const variantBtn = document.querySelectorAll(".product-form__label.available");

variantBtn.forEach((btn) => {
  btn.onclick = function () {
    setTimeout(() => {
      const form = btn.closest("[bss-b2b-main-product-form]");
      if (form) {
        BSS_B2B.observer.productSubject.notifyObserver(
          "VariantChange",
          "VariantSelectChange",
          { productForm: form }
        );
      }
    }, 300);
  };
});

document.addEventListener("BSS:changeVariantQV", (e) => {
  setTimeout(() => {
    const productForm = document.querySelector(
      "[bss-b2b-quickview-product-form]"
    );
    BSS_B2B.observer.productSubject.notifyObserver(
      "VariantChange",
      "VariantSelectChange",
      { productForm }
    );
  }, 500);
});

if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  document.addEventListener("DOMContentLoaded", function () {
    document.body.addEventListener("click", function (e) {
      const quickViewBtn = e.target.closest("[bss-b2b-btn-quickview]");
      if (quickViewBtn) {
        setTimeout(() => {
          document.dispatchEvent(new Event("bss_b2b:QuickviewLoaded"));
        }, 1000);

        setTimeout(() => {
          const secondQuickViewForm = document.querySelectorAll(
            'form[id^="product-quick-view-form"]'
          )[1];

          if (
            secondQuickViewForm &&
            !secondQuickViewForm.previousElementSibling?.classList.contains(
              "bss-b2b-qb-table-on-quick-view"
            )
          ) {
            const div = document.createElement("div");
            div.className = "bss-b2b-qb-table-on-quick-view";
            secondQuickViewForm.parentNode.insertBefore(
              div,
              secondQuickViewForm
            );
          }
        }, 1000);
      }
    });
  });

  // Observe Cart Preview changes
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      for (let item of MutationList) {
        if (item.target.classList.contains("previewCart-wrapper")) {
          setTimeout(() => {
            const priceElements = [
              document
                .querySelector(".previewCartTotals.subTotal.clearfix")
                ?.querySelector(".previewCartTotals-value"),
              document
                .querySelector(".previewCartTotals.total.clearfix")
                ?.querySelector(".previewCartTotals-value"),
            ];

            priceElements.forEach((el) => {
              if (el) el.setAttribute("bss-b2b-cart-total-price", true);
            });

            BSS_B2B.observer.cartSubject.notifyObserver(
              "CartUpdate",
              "CartMutate"
            );
          }, 300);

          //Listen cart-slider checkout event
          const checkoutBtn = document.querySelector("#cart-sidebar-checkout");
          if (checkoutBtn) {
            const originalHandler = checkoutBtn.onclick;

            checkoutBtn.onclick = function (e) {
              e.preventDefault();
              BSS_B2B.observer.cartSubject.listenCartCheckout();
            };
          }
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);

  // Listen cart checkout event
  document.addEventListener("bss_b2b:listenCartCheckout", () => {
    BSS_B2B.observer.cartSubject.listenCartCheckout();
  });
}
